import { NoOptionButton, OKOptionButton } from "../../Common/Buttons/Button";
import type { ShopfrontThunk } from "../../Utilities/Generic/ActionsHelper";
import { setOption } from "../../Utilities/Platform/Options/Options";
import { sendAction, sendSecurityEvent } from "../../Workers/Upload/UploadAgent";
import { showDialog, type ShowDialogAction } from "../Dialogs/DialogActions";
import {
    DATABASE_BLOCKED,
    INFORMATION_FIRST_VIEW,
    INFORMATION_OFFLINE,
    INFORMATION_ONLINE,
    INFORMATION_SET_TRAINING,
} from "./InformationConstants";

interface InformationOnlineAction {
    type: typeof INFORMATION_ONLINE;
}

interface InformationOfflineAction {
    type: typeof INFORMATION_OFFLINE;
}

interface InformationFirstViewAction {
    type: typeof INFORMATION_FIRST_VIEW;
}

interface InformationSetTrainingAction {
    type: typeof INFORMATION_SET_TRAINING;
    data: boolean;
}

export interface DatabaseBlockedAction {
    type: typeof DATABASE_BLOCKED;
    certain: boolean;
}

export type InformationActionType =
    InformationOnlineAction |
    InformationOfflineAction |
    InformationFirstViewAction |
    InformationSetTrainingAction |
    DatabaseBlockedAction;

export interface InformationState {
    online: boolean;
    training: boolean;
    firstVisit: boolean;
    databaseBlocked: {
        blocked: boolean;
        certain: boolean;
    };
}

export function online(): ShopfrontThunk<InformationActionType> {
    return (dispatch, getState): void => {
        const state = getState();

        if(state.information.online) {
            return;
        }

        dispatch({
            type: INFORMATION_ONLINE,
        });
    };
}

export function offline(): ShopfrontThunk<InformationActionType> {
    return (dispatch, getState): void => {
        const state = getState();

        if(!state.information.online) {
            return;
        }

        dispatch({
            type: INFORMATION_OFFLINE,
        });
    };
}

export function firstView(): InformationActionType {
    return {
        type: INFORMATION_FIRST_VIEW,
    };
}

export function toggleTraining(): ShopfrontThunk<InformationActionType | ShowDialogAction> {
    return (dispatch, getState): void => {
        const state = getState();
        const register = state.location.register;

        const value = !state.information.training;

        const finish = (): void => {
            void sendAction("TRAINING_MODE", "App\\Models\\Register", (register?.id ?? ""), {
                enabled: value,
            });

            void sendSecurityEvent("TRAINING_MODE", {
                enabled: value,
            });

            setOption("training_mode_enabled", value);

            dispatch({
                type: INFORMATION_SET_TRAINING,
                data: value,
            });
        };

        if(value) {
            if(window.location.pathname !== "/") {
                dispatch(showDialog(
                    "Return to Sell Screen",
                    <div style={{ maxWidth: "450px" }}>
                        <p>
                            To enable training mode, please return to the sell screen.
                        </p>
                    </div>,
                    "warning",
                    [ OKOptionButton ]
                ));

                return;
            }

            dispatch(showDialog(
                "Enable Training Mode",
                <div style={{ maxWidth: "450px" }}>
                    <p>
                        Training mode allows you to learn how to use the register without
                        affecting your day&apos;s sales. All processed while in training mode
                        will be lost, are you sure you wish to continue?
                    </p>
                </div>,
                "warning",
                [ NoOptionButton, {
                    label   : "Yes",
                    classes : [ "button-warning" ],
                    callback: finish,
                }]
            ));
        } else {
            finish();
        }
    };
}

export function databaseBlocked(certain: boolean): DatabaseBlockedAction {
    return {
        type: DATABASE_BLOCKED,
        certain,
    };
}
